/* src/app/shared/contract/contract-list/contract-creating-dialog/contract-creating-dialog.component.scss */
form {
  height: 100%;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  width: auto;
  margin: 0;
  border: red 10px;
}
.light-blue-horizontal-separator {
  height: 1px;
  background-color: #DFEBF7;
}
.loaded-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}
.bloc-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: auto;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.red-title {
  font: 700 16px FranceTV Brown;
  color: #F03C64;
}
.inputs-bloc-container {
  display: flex;
  gap: 10px;
}
.content-position {
  align-items: center;
  width: 100%;
}
.button-edit {
  justify-content: flex-end;
  display: flex;
  width: 100%;
}
.tv-ns-secondary-large-button-on-light-bg {
  width: 150px;
  margin-right: 15px;
}
.tv-ns-validation-large-button {
  width: 150px;
}
.full-width {
  flex: auto;
}
.two-thirds-width {
  flex: 2;
}
.one-third-width {
  flex: 1;
}
.spinner {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
/*# sourceMappingURL=contract-creating-dialog.component.css.map */
